module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Braven.360adec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Braven.jpg
// module id = Ldhd
// module chunks = 0